import { render } from "./XIconSolidSwatches.vue?vue&type=template&id=b4f15026"
import script from "./XIconSolidSwatches.vue?vue&type=script&lang=js"
export * from "./XIconSolidSwatches.vue?vue&type=script&lang=js"

import exportComponent from "/home/omid_es327/Projects/mohovers/dev/dev-laravel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"XIconSolidSwatches.vue"]])

export default __exports__